import script from "./BaseView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseView.vue?vue&type=script&lang=ts&setup=true"

import "./BaseView.vue?vue&type=style&index=0&id=d72d6626&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d72d6626"]])

export default __exports__